<ng-template #orderSlip let-order="order">
    <div class="printing printing--thermal" *ngIf="order">
        <div class="print-view print-view--thermal">
            <table>
                <tr style="border-bottom: 1px solid black;">
                    <td colspan="6" class="bold left">{{order.order}}</td>
                    <td colspan="6" *ngIf="order.table !== null" class="bold right">{{tr('@place_print_ticket_table')}}: {{order.table}}</td>
                    <td colspan="6" *ngIf="order.table === null" class="bold right">{{tr('@place_print_ticket_barticket')}}</td>
                </tr>
                <tr *ngIf="order.diners !== null">
                    <td colspan="6" class="bold left">{{tr('@place_print_ticket_diners')}}</td>
                    <td colspan="6" class="bold right">{{order.diners}}</td>
                </tr>
            </table>

            <table>
                <tr *ngIf="order.action === 'del'">
                    <td colspan="12" style="text-transform: uppercase;">{{tr('@place_print_ticket_canceled')}}</td>
                </tr>
                <tr *ngIf="order.action !== 'del'">
                    <td colspan="8" *ngIf="order.action === 'new'" style="text-transform: uppercase;">{{tr('@place_print_ticket_newticket')}}</td>
                    <td colspan="8" *ngIf="order.action === 'set'" style="text-transform: uppercase;">{{tr('@place_print_ticket_udtticket')}}</td>
                    <td colspan="8" *ngIf="order.action === 'cpy'" style="text-transform: uppercase;">{{tr('@place_print_ticket_copyticket')}}</td>
                    <td colspan="4" class="right">{{order.time}}</td>
                </tr>
                <tr><td colspan="12" style="height:5px"></td></tr>
            </table>

            <table *ngIf="order.comments && (order.action !== 'del')">
                <tr>
                    <td class="italic">{{order.comments}}</td>
                </tr>
            </table>

            <ng-container *ngIf="order.additions.length > 0">
                <table>
                    <tr style="border-bottom: 1px solid black;">
                        <td colspan="12" class="bold">{{tr('@place_print_ticket_newitems')}}</td>
                    </tr>
                    <tr><td colspan="12" style="height:5px"></td></tr>
                    <ng-container *ngFor="let _line of order.additions">
                        <tr *ngIf="_line.isSeparator">
                            <td colspan="12" class="order-separator">{{tr('@place_print_ticket_separate')}}</td>
                        </tr>
                        <ng-container *ngIf="!_line.isSeparator">
                            <tr>
                                <td colspan="12" class="left">
                                    <div class="ticket-item">
                                        <span *ngIf="_line.weight === null">{{_line.count}} x</span>
                                        <span *ngIf="_line.weight !== null">{{(_line.weight / 1000).toFixed(2)}}{{tr('@kilograms')}} x</span>
                                        <span style="text-transform: uppercase;"> {{_line.name}}</span>
                                    </div>
                                </td>
                            </tr>
                            <tr *ngIf="_line.comments">
                                <td colspan="12" class="italic">{{_line.comments}}</td>
                            </tr>
                        </ng-container>
                    </ng-container>
                </table>
            </ng-container>

            <ng-container *ngIf="order.removals.length > 0">
                <table>
                    <tr style="border-bottom: 1px solid black;">
                        <td colspan="12" class="bold">{{tr('@place_print_ticket_delitems')}}</td>
                    </tr>
                    <tr><td colspan="12" style="height:5px"></td></tr>
                    <ng-container *ngFor="let _line of order.removals">
                        <tr *ngIf="_line.isSeparator">
                            <td colspan="12" class="order-separator">{{tr('@place_print_ticket_separate')}}</td>
                        </tr>
                        <ng-container *ngIf="!_line.isSeparator">
                            <tr>
                                <td colspan="12" class="left">
                                    <div class="ticket-item">
                                        <span *ngIf="_line.weight === null">{{_line.count}} x</span>
                                        <span *ngIf="_line.weight !== null">{{(_line.weight / 1000).toFixed(2)}}{{tr('@kilograms')}} x</span>
                                        <span class="strike">
                                            <span style="text-transform: uppercase;"> {{_line.name}}</span>
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr *ngIf="_line.comments">
                                <td colspan="12" class="italic">{{_line.comments}}</td>
                            </tr>
                        </ng-container>
                    </ng-container>
                </table>
            </ng-container>

            <div style="clear: both; height: 60px;"></div>
        </div>
    </div>
</ng-template>

<!-- Preview: single visible slip -->
<div *ngIf="display" class="order-preview-host">
    <ng-container *ngTemplateOutlet="orderSlip; context: { order: Info }"></ng-container>
</div>

<!-- Silent dispatch: one destination rendered at a time via Printable() -->
<div class="printing order-dispatch-host" *ngIf="!display && IsPrinting" aria-hidden="true">
    <div #printable class="print-view">
        <ng-container *ngTemplateOutlet="orderSlip; context: { order: DispatchInfo }"></ng-container>
    </div>
</div>
